import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { BvDialogService } from "../design-system";
import { ClubService } from "./club.service";
import { ProfileService } from "./profile.service";
import { PromptDialogComponent } from "../shared/prompt-dialog/prompt-dialog.component";
import { JoinClubComponent } from "../lobby/join-club/join-club.component";

/**
 * "Create a club" and "Join a club" entry points, shared by the sidebar and
 * the lobby's no-club empty state.
 */
@Injectable({ providedIn: "root" })
export class ClubActionsService {
  constructor(
    private dialog: BvDialogService,
    private translate: TranslateService,
    private clubServ: ClubService,
    private profServ: ProfileService
  ) {}

  promptNewClub(): void {
    this.translate
      .get(["CREATE_CLUB", "CLUB_NAME", "CONFIRM", "CANCEL"])
      .subscribe((res: any) => {
        this.dialog
          .open(PromptDialogComponent, {
            data: {
              message: res["CLUB_NAME"] + ":",
              title: res["CREATE_CLUB"],
              acceptButton: res["CONFIRM"],
              cancelButton: res["CANCEL"],
            },
            panelClass: "prompt-dialog-container",
          })
          .afterClosed()
          .subscribe((newValue: string) => {
            if (newValue) {
              const prof = this.profServ.latestProfile;
              this.clubServ.newClub(
                newValue,
                prof.dispName,
                prof.subLevel,
                prof.player_limit,
                prof.imgURL
              );
            }
          });
      });
  }

  openJoinClub(): void {
    this.dialog.open(JoinClubComponent);
  }
}
